/**
 * @module cp-utils
 *
 * @usageNotes
 * ```
 * import { is, has, toFixedDecimalNum, rCurry, rPath, rCompose, rClone } from 'app/ag-utils';
 * ```
 *
 * @description
 * Entry point for all utility functions used across the app.
 *
 * This is the new ag-utils folder to manage all utility functions we use across the app.
 * Keeping everything in one central location, will give it more visibility for every developer
 * to make this their stopping point to see if a func that does what they need already exists.
 *
 * It will also make it easy to take out or update utility funcs as the consumer components or
 * service will all be pointing here.
 *
 * This is just a starting point. Please add all funcs you think someone can reuse. If its already in
 * your file, we can save some microbytes :) by you moving it here and making it available to others.
 *
 * Add tests.
 *
 * And feel free to update current ones here. But whatever you do, keep it simple. If a new team mate can't
 * read it and get it, it probably should not be here.
 *
 * Please prefer native ES6 methods. Both for sustenance, readability, 'stackoverflowing", "100x performance".
 *
 * Also, please use descriptive names for params. If something is not clear, anyone can update it accordingly.
 *
 * Anyone can/should add to and update any of these methods.
 *
 */

// Async State
import {isEmpty, sample} from 'rxjs/operators';
import isNil from './misc/is-nil';

// import {
//     isArray,
//     isObject,
//     isNumber,
//     isString,
//     isEmpty,
//     isNaN,
//     isNil,
//     isNull,
//     pick,
//     sample,
//     shuffle,
//     isEqual,
// } from 'lodash';

export {
  isEmpty,
  isNil,
  sample,
  // Async Data
  // AsyncDataItem,
  // AsyncDataItemState,
  // wrapAsAsyncDataItem,
  // unwrapAsyncDataItem,
  // queryAsyncState,
};

// export function isNilOrEmpty(value: string | null): boolean {
//     return isNil(value) || isEmpty(value);
// }
